import korzaLogoBlackBlue from '@/assets/korza_logo_black_blue.png';
import { Waves } from '@/pages/onboarding/mockup/waves';

// Decorative backdrop for the onboarding mockup column: React Bits' Waves
// background (`./waves.tsx`) — a sparse grid of brand-blue lines undulating
// over a faint tint — instead of a flat placeholder color. Picked after the
// shader-based Aurora/Silk attempts read as too dense for this column.
//
// `bg-muted/50` instead of plain white: with the form column beside it also
// white, the two columns blended into one slab with only a 1px border
// between them to tell them apart — too subtle a seam on its own. A tint
// across the whole column gives it its own identity at a glance, the border
// just crisps up the edge between the two already-distinct zones.
export function KorzaStudioBackdrop() {
  return (
    <div className="absolute inset-0 overflow-hidden rounded-[inherit] bg-muted/50">
      <Waves
        lineColor="#155dfc33"
        waveAmpX={24}
        waveAmpY={12}
        xGap={16}
        yGap={40}
      />
    </div>
  );
}

// Rendered as its own sibling, after (not inside) the mockup in
// OnboardingPageLayout, specifically so it stacks above it — a zoomed
// mockup (ZoomedIPhoneMockup) can now grow tall enough to sit right over
// where this badge lives. The frosted glass backing keeps it legible
// regardless of what ends up behind it (the dark device bezel, a busy
// wallpaper, app icons) instead of just blending in or disappearing.
export function KorzaStudioBadge() {
  return (
    <div className="pointer-events-none absolute bottom-6 right-6 z-20 flex items-center gap-2 rounded-full bg-white/70 px-3 py-1.5 shadow-sm ring-1 ring-black/5 backdrop-blur-md">
      <img
        src={korzaLogoBlackBlue}
        alt=""
        aria-hidden
        className="h-4 object-contain"
      />
      <span className="text-sm font-light tracking-wide text-foreground/80">
        Studio
      </span>
    </div>
  );
}
